<template>
    <form action="javascript:void(0)" novalidate>
      <v-card-title class="subtitle-2 text-uppercase">Grid Settings</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Container Width (px)"
              type="number"
              min="1" step="1"
              hide-details
              v-model="settings.containerWidth"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="No. of grids"
              type="number"
              min="1" step="1"
              hide-details
              v-model="settings.totalGrids"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="Gap Size (px)"
              type="number"
              min="1" step="1"
              hide-details
              v-model="settings.gutterSpace"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-btn color="accent" block depressed @click.prevent="onSubmit">Update Layout</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </form>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'grid-settings-form',
  data() {
    return {
      settings: {},
    };
  },
  computed: {
    ...mapState({
      defaultSettings: 'settings',
    }),
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.settings);
    },
  },
  created() {
    this.settings = {
      ...this.defaultSettings,
    };
  },
};
</script>
